import React from "react";

const Logo = (props) => {
  return <img src="images/fulilizo_logo.svg" alt="Logo" {...props} />;
};

export default Logo;
